import {AddressField} from '../interfaces/address-field';


export class DiscountCode {
  public id: number;
  public code: string;
  public starts_at: Date;
  public ends_at: Date;
  public description: string;
  public unique_assignment: boolean;
  public discount_type: string;
  public ordering_type: string;
  public discount_category: string;
  public max_uses: number;
  public covers_tax: boolean;
  public add_free_shipping: boolean;
  public personal_addresses_allowed: boolean;
  public condition_selection: string;
  public condition_subtype: string;
  public discount: string;
  public assigned_addresses: AddressField[]; // might be empty in case of personal_addresses_allowed = TRUE
  public error_message: string;
  public discount_condition: [{
      selection: string,
      sub_type: string | null
  }]

  constructor(data) {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    if (data) {
      Object.assign(this, data);
    }
  }

  get hasError(): boolean {
    return !!this.error_message;
  }
}
